/*
    fake-non-partner-referrals.js

    this simulates the API data for Referrals
    each Section contains Question objects
    check with Vito - questions will have GUID ids (not per section)

    NOTE: the questionTypes must match exactly to render UI controls! 

    The questions on screen generally have a left and right side.
    Text on the left and UI control(s) on the right.

    For OBJECT types this layout is ignore and the whole screen width is used.
    The objectType (ie USER_INFO) corresponds to a custom Svelte component.
    The component will have all the fields needed for that object.
*/


// questionTypes
import {
    SHORT_TEXT,
    LONG_TEXT,
    SINGLE_CHOICE,
    MULTI_CHOICE,
    NUMBER,
    DATE,
    SELECTION,
    BOOLEAN_CHECKBOX,
    RATING_STARS,
    // render custom UI fields
    OBJECT,
    CONTACT_INFO,
    MYSELF_INFO
} from './question-types.js';


// TODO: THIS OBJECT NEEDS TO COME FROM BACK END!
const myselfInfo = {
    firstName: {label: 'First Name', value: null, isRequired: true},
    lastName: {label: 'Last Name', value: null, isRequired: true},
    phoneNumber: {label: 'Phone Number', value: null, isRequired: true},
    email: {label: 'Email', value: null, isRequired: true}
}

// TODO: THIS OBJECT NEEDS TO COME FROM BACK END!
const contactInfo = {
    firstName: {label: 'First Name', value: null, isRequired: true},
    lastName: {label: 'Last Name', value: null, isRequired: true},
    address1: {label: 'Address 1', value: null, isRequired: false},
    address2: {label: 'Address 2', value: null, isRequired: false},
    county: {label: 'County', value: null, isRequired: false},
    state: {label: 'State', value: null, isRequired: false},
    city: {label: 'City', value: null, isRequired: false},
    postalCode: {label: 'ZIP Code', value: null, isRequired: true},
    phoneNumber: {label: 'Phone Number', value: null, isRequired: true},
    email: {label: 'Email', value: null, isRequired: true}
}

export const SECTION_SEND_REFERRAL = {
    sectionId: "send-referral",
    sectionlabel: "Save Resource",
    nextSectionId: "contact-info",
    questions: [
        {
            id: "0000-0000",
            questionType: SINGLE_CHOICE,
            label: "Who are you filling out this resource for?",
            options: [
                {label: "Myself", value: "myself"},
                {label: "Someone else", value: "someone else"}
            ],
            isRequired: true,
            value: 'myself'
        },
        {
            id: "0000-0001",
            questionType: OBJECT,           // flag to override the Question layout
            label: null,
            options: null,
            objectType: MYSELF_INFO,         // for the correct field layouts
            isRequired: false,               // need a way to determine required fields
            value: myselfInfo,
            depId: '0000-0000',
            depValue: 'someone else'
        },
        {
            id: "0000-0002",
            questionType: SELECTION,
            label: "What is your relationship to the person you are filling this out for?",
            options: [
                {label: "Spouse", value: 'spouse'},
                {label: "Partner", value: 'partner'},
                {label: "Friend", value: 'friend'},
                {label: "Child", value: 'child'},
                {label: "Parent", value: 'parent'},
                {label: "Other", value: 'other'}
            ],
            isRequired: false,
            value: null,
            depId: '0000-0000',
            depValue: 'someone else'
        }
    ]
}

export const SECTION_CONTACT_INFO = {
    sectionId: "contact-info",
    sectionlabel: "Contact Information",
    nextSectionId: "service-specific",
    questions: [
        // {
        //     id: "0001-0000",
        //     questionType: SINGLE_CHOICE,
        //     label: "Who are you filling out this referral for?",
        //     options: [
        //         {label: "Myself", value: "myself"},
        //         {label: "Someone else", value: "someone else"}
        //     ],
        //     isRequired: true,
        //     value: null
        // },
        {
            id: "0001-0001",
            questionType: OBJECT,           // flag to override the Question layout
            label: null,
            options: null,
            objectType: CONTACT_INFO,          // for the correct field layouts
            isRequired: true,               // need a way to determine required fields
            value: contactInfo
        },
        // {
        //     id: "0000-0002",
        //     questionType: MULTI_CHOICE,
        //     label: "Who should we share this referral with?",
        //     options: [
        //         {label: "Me", value: "me"},
        //         {label: "This Service", value: "this service"},
        //         {label: "Our Partners", value: "our partners"}
        //     ],
        //     isRequired: true,
        //     value: null
        // }
    ]
}

export const SECTION_SERVICE_SPECIFIC = {
    sectionId: "service-specific",
    sectionlabel: "Planning for Service",
    nextSectionId: null,
    questions: [
        {
            id: "0002-0000",
            questionType: SINGLE_CHOICE,
            label: "Will you need transportation assistance to this service?",
            options: [
                {label: "Yes", value: true},
                {label: "No", value: false}
            ],
            isRequired: false,
            value: null
        },
        {
            id: "0002-0001",
            questionType: SINGLE_CHOICE,
            label: "Will you need assistance at home while you travel to this service?",
            options: [
                {label: "Yes", value: true},
                {label: "No", value: false}
            ],
            isRequired: false,
            value: null,
            depId: null,
            depValue: null
        },
        {
            id: "0002-0002",
            questionType: SINGLE_CHOICE,
            label: "Will you need assistance at home while you travel to this service?",
            options: [
                {label: "Yes", value: true},
                {label: "No", value: false}
            ],
            isRequired: false,
            value: null
        },
        {
            id: "0002-0003",
            questionType: MULTI_CHOICE,
            label: "What kind of help will you need while you are away?",
            options: [
                {label: "Respite Care", value: "respite care"},
                {label: "Child Daycare", value: "child daycare"},
                {label: "Adult Daycare", value: "adult daycare"},
                {label: "Pet Sitting", value: "pet sitting"},
                {label: "House Sitting", value: "house sitting"}
            ],
            isRequired: false,
            value: null,
            depId: '0002-0002',
            depValue: true
        },
        /*
        {
            id: "0002-0004",
            questionType: SINGLE_CHOICE,
            label: "Can we share this information with our Respite Partners to contact you?",
            options: [
                {label: "Yes", value: true},
                {label: "No", value: false}
            ],
            isRequired: true,
            value: null,
            depId: '0002-0003',
            depValue: 'respite care'
        },
        {
            id: "0002-0005",
            questionType: SINGLE_CHOICE,
            label: "Can we share this information with our Child Day Partners to contact you?",
            options: [
                {label: "Yes", value: true},
                {label: "No", value: false}
            ],
            isRequired: false,
            value: null,
            depId: '0002-0003',
            depValue: 'child daycare'
        },
        {
            id: "0002-0006",
            questionType: SINGLE_CHOICE,
            label: "Can we share this information with our Adult Daycare Partners to contact you?",
            options: [
                {label: "Yes", value: true},
                {label: "No", value: false}
            ],
            isRequired: false,
            value: null,
            depId: '0002-0003',
            depValue: 'adult daycare'
        },
        {
            id: "0002-0007",
            questionType: SINGLE_CHOICE,
            label: "Can we share this information with our Partners to arrange for a Pet Sitter?",
            options: [
                {label: "Yes", value: true},
                {label: "No", value: false}
            ],
            isRequired: false,
            value: null,
            depId: '0002-0003',
            depValue: 'petsitting'
        },
        {
            id: "0002-0008",
            questionType: SINGLE_CHOICE,
            label: "Can we share this information with our Partners to arrange for a House Sitter?",
            options: [
                {label: "Yes", value: true},
                {label: "No", value: false}
            ],
            isRequired: false,
            value: null,
            depId: '0002-0003',
            depValue: 'housesitting'
        },
        */
        {
            id: "0002-0009",
            questionType: SINGLE_CHOICE,
            label: "Will you need financial assistance to access this service?",
            options: [
                {label: "Yes", value: true},
                {label: "No", value: false}
            ],
            isRequired: false,
            value: null
        }
    ]
}

